import { createAction } from '@helpers/createAction'

export const SET_PLAYER = 'SET_PLAYER'
export const SET_PLAYER_PIP = 'SET_PLAYER_PIP'

export default {
  [SET_PLAYER]: createAction(SET_PLAYER),
  [SET_PLAYER_PIP]: createAction(SET_PLAYER_PIP),
}
